import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { X } from 'lucide-react'
import { useAppShell } from '@/contexts/AppShellContext'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { SidebarNavContent } from '@/components/SidebarNavContent'
import { BrandLogoMark } from '@/components/brand/BrandLogoMark'
import { useI18n } from '@/i18n'

/**
 * Overlay navigation: full-screen on phone, left drawer on tablet. Hidden on desktop.
 */
export function NavDrawer() {
  const isDesktop = useMediaQuery('(min-width: 1280px)')
  const isMobile = useMediaQuery('(max-width: 767px)')
  const { menuOpen, closeMenu } = useAppShell()
  const location = useLocation()
  const { t } = useI18n()

  useEffect(() => {
    closeMenu()
  }, [location.pathname, closeMenu])

  useEffect(() => {
    if (isDesktop) closeMenu()
  }, [isDesktop, closeMenu])

  if (isDesktop || !menuOpen) {
    return null
  }

  return (
    <div className="nav-drawer-backdrop" onClick={closeMenu} role="presentation">
      <div
        id="app-nav-drawer"
        className={`nav-drawer-panel ${isMobile ? 'nav-drawer-panel--fullscreen' : 'nav-drawer-panel--tablet'}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label="Application menu"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="nav-drawer-panel__top">
          <div className="nav-drawer-panel__brand">
            <BrandLogoMark />
            <span className="nav-drawer-panel__title">{t('app.name', 'DefendSphere')}</span>
          </div>
          <button
            type="button"
            className="nav-drawer-panel__close"
            onClick={closeMenu}
            aria-label={t('buttons.closeNavigationMenu', 'Close menu')}
          >
            <X className="h-6 w-6" aria-hidden />
          </button>
        </div>
        <div className="nav-drawer-panel__body">
          <SidebarNavContent
            className="sidebar-nav-content--drawer"
            onNavigate={closeMenu}
            showBrand={false}
          />
        </div>
      </div>
    </div>
  )
}
